import React, { useEffect } from "react";

import Subscription from "./Subscription";

import { Provider } from "@shopify/app-bridge-react";

import { CmsConstructor } from "../helpers/cmsConstructor";
import { useCmsHook } from "../helpers/cmsHook";
import CmsEditAndSave from "../helpers/CmsEditAndSave";

const ManagePlan = () => {
  const { setCmsInstance } = useCmsHook();

  const config = {
    apiKey: process.env.REACT_APP_SHOPIFY_CLIENT,
    host: new URLSearchParams(window.location.search).get("host"),
  };

  useEffect(() => {
    if (window.location.pathname === "/manage-plan") {
      const cmsInstance = async () => {
        const cmsObj = await CmsConstructor();
        setCmsInstance(cmsObj);
      };
      cmsInstance();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Provider config={config}>
      <div>
        <CmsEditAndSave />
      </div>
      <Subscription />
    </Provider>
  );
};

export default ManagePlan;
